export const WIZARD_STEPS = [
  { id: 'basic', label: 'Basic', shortLabel: 'Basic' },
  { id: 'participants', label: 'Participants', shortLabel: 'People' },
  { id: 'rules', label: 'Rules', shortLabel: 'Rules' },
  { id: 'notifications', label: 'Reminders & Notifications', shortLabel: 'Notify' },
  { id: 'completion', label: 'Completion Actions', shortLabel: 'Post Complete' },
  { id: 'attachments', label: 'Attachments', shortLabel: 'Attachment' },
  { id: 'review', label: 'Review & Publish', shortLabel: 'Review' },
];

export const hasEventScheduleDate = (form) => Boolean(String(form?.schedule?.startDate || '').trim());

export const rulesConfiguredOnBasic = (form) => {
  const type = String(form?.eventType || '').toUpperCase();
  return type === 'SPLITWISE' || type === 'EXPENSE_TRACKING';
};

export const visibleWizardSteps = (form) => {
  const type = String(form?.eventType || '').toUpperCase();
  if (type === 'POLL' || type === 'ACTION_TRACKING') {
    return WIZARD_STEPS.filter((step) => step.id === 'basic');
  }
  return WIZARD_STEPS.filter((step) => {
    if (step.id === 'rules' && rulesConfiguredOnBasic(form)) return false;
    if (step.id === 'notifications' && !hasEventScheduleDate(form)) return false;
    return true;
  });
};
